import { render } from "./Deactivate2FA.vue?vue&type=template&id=74683fa4&scoped=true"
import script from "./Deactivate2FA.vue?vue&type=script&lang=js"
export * from "./Deactivate2FA.vue?vue&type=script&lang=js"

import "./Deactivate2FA.vue?vue&type=style&index=0&id=74683fa4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74683fa4"]])

export default __exports__